import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const MaterialsIndent = lazy(() => import('../modules/materials-indent'));

const MaterialsIndentTable = lazy(
  () => import('../modules/materials-indent/pages/MaterialsIndentTable')
);
const MaterialsIndentDetails = lazy(
  () => import('../modules/materials-indent/pages/MaterialsIndentDetails')
);
const CreateMaterialsIndent = lazy(
  () => import('../modules/materials-indent/pages/CreateMaterialsIndent')
);
const EditMaterialsIndent = lazy(
  () => import('../modules/materials-indent/pages/EditMaterialsIndent')
);
const CloneMaterialsIndent = lazy(
  () => import('../modules/materials-indent/pages/CloneMaterialsIndent')
);
const MaterialsIndentDispatch = lazy(
  () => import('../modules/materials-indent/pages/MaterialsIndentDispatch')
);
const MaterialsIndentDispatchPO = lazy(
  () => import('../modules/materials-indent/pages/MaterialsIndentDispatchPO')
);

const MaterialsIndentRoutes = (
  <>
    <Route
      path="materials-indent"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <MaterialsIndent />
        </Suspense>
      }
    >
      <Route
        path="new/create"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.MATERIAL_INDENT_CREATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <CreateMaterialsIndent />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=":mId/edit"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.MATERIAL_INDENT_UPDATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <EditMaterialsIndent />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=":mId/clone"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.MATERIAL_INDENT_CLONE]}>
            <Suspense fallback={<SkeletonPage />}>
              <CloneMaterialsIndent />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=":mId/dispatch"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <MaterialsIndentDispatch />
          </Suspense>
        }
      />
      <Route
        path=":mId/dispatch-po"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <MaterialsIndentDispatchPO />
          </Suspense>
        }
      />
      <Route
        path=":mId/:action/:details?"
        element={
          <RBACRoute
            privileges={[PRIVILEGES.COMMON.MATERIAL_INDENT_DETAILS_VIEW]}
          >
            <Suspense fallback={<SkeletonPage />}>
              <MaterialsIndentDetails />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.MATERIAL_INDENT_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <MaterialsIndentTable />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default MaterialsIndentRoutes;
